// SSE client for POST /ai-insights/ask. EventSource can't POST, so we stream the response body
// with fetch() + a ReadableStream reader and parse SSE frames. Frames: `event: meta` (conversationId),
// `event: status` (a tool is running), plain `data:` frames with text deltas, `event: done` / `event: error`.
import Config from '../../Config.js';
import axiosV2 from '../../core/http/axios_api_v2';

function handleFrame(frame, cb) {
  let event = 'message';
  let dataLine = '';
  frame.split('\n').forEach(line => {
    if (line.indexOf('event:') === 0) event = line.slice(6).trim();
    else if (line.indexOf('data:') === 0) dataLine += line.slice(5).trim();
  });
  let obj = null;
  try { obj = dataLine ? JSON.parse(dataLine) : null; } catch (e) { obj = null; }
  if (event === 'done') { if (cb.onDone) cb.onDone(obj || {}); return; }
  if (event === 'error') { if (cb.onError) cb.onError(obj && obj.message ? obj.message : 'שגיאה'); return; }
  if (event === 'meta') { if (cb.onMeta && obj) cb.onMeta(obj); return; }
  if (event === 'status') { if (cb.onStatus && obj) cb.onStatus(obj); return; }
  if (obj && obj.delta && cb.onDelta) cb.onDelta(obj.delta);
}

// Returns an abort() function the caller can use to cancel the stream.
export function askInsights(body, cb) {
  cb = cb || {};
  const base = (Config.SETTINGS.API_V2_URL || '').replace(/\/$/, '');
  const url = base + '/ai-insights/ask';
  const headers = { 'Content-Type': 'application/json' };
  const tenantId = localStorage.getItem('tenantId');
  if (tenantId) headers['x-tenant-id'] = tenantId;
  // The app's axios instance carries the bearer token (set by store.js on login); a plain fetch
  // doesn't, and every non-public route requires it.
  const auth = axiosV2.defaults.headers.common['Authorization'];
  if (auth) headers['Authorization'] = auth;
  const controller = new AbortController();

  fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body), signal: controller.signal })
    .then(resp => {
      if (!resp.ok || !resp.body) {
        if (resp.status === 401) { if (cb.onError) cb.onError('פג תוקף החיבור, יש להתחבר מחדש.'); return; }
        return resp.text().then(text => {
          let msg = 'שגיאת שרת (' + resp.status + ')';
          try { const o = JSON.parse(text); if (o && o.message) msg = String(o.message); } catch (e) { /* noop */ }
          if (cb.onError) cb.onError(msg);
        });
      }
      const reader = resp.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';
      function pump() {
        return reader.read().then(chunk => {
          if (chunk.done) { if (cb.onDone) cb.onDone({}); return; }
          buffer += decoder.decode(chunk.value, { stream: true });
          let idx = buffer.indexOf('\n\n');
          while (idx !== -1) {
            const frame = buffer.slice(0, idx);
            buffer = buffer.slice(idx + 2);
            handleFrame(frame, cb);
            idx = buffer.indexOf('\n\n');
          }
          return pump();
        });
      }
      return pump();
    })
    .catch(err => { if (err && err.name !== 'AbortError' && cb.onError) cb.onError('שגיאת רשת'); });

  return () => controller.abort();
}
